<template>
    <div class="lt">
      <div class="lt-bottom" v-if="defaultdata && defaultdata.length">
        <div
          class="lt-bt-item"
          v-for="(item, index) in defaultdata.slice(0, 4)"
          :key="index"
          v-if="item && item.value1"
        >
          <img
            src="../../assets/temimg2/l1-btimg-max.png"
            alt=""
            class="bt-bg-img"
          />
          <img src="../../assets/temimg2/l1-icon.png" alt="" class="bt-icon" />
          <div
            class="lt-item-title ellipsis"
            style="width: 100px"
            :title="item.value1"
          >
            {{ item.value1 }}
          </div>
          <div class="lt-item-content">
            <div class="item-num">{{ numformat(item.value2, 2) }}</div>
            <div class="item-unit" v-if="item.value3">{{ item.value3 }}</div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import * as methods from "./method.js";
  export default {
    name: "template.scope76",
    props: {
      vdata: {
        type: [Array, String],
        default: () => [],
      },
      jsondata: {
        type: [Array, String],
        default: () => [],
      },
      scopedata: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        //此页面的value2数据需要做限制，defaultdata需要做限制，最多展示6个
        title: "scope12-【组件】图文-4组数据8-完成",
        defaultdata: [
          { value1: "文本一", value2: "000", value3: "单位" },
          { value1: "文本二", value2: "000", value3: "单位" },
          { value1: "文本三", value2: "000", value3: "单位" },
          { value1: "文本四", value2: "000", value3: "单位" },
        ],
        valueMap: [
          { name: "名称", key: "value1" },
          { name: "数值", key: "value2" },
          { name: "单位", key: "value3" },
        ],
        exceldata: [],
        apiconfig: {},
        isApi: false,
        scope: {},
      };
    },
    watch: {
      vdata(n) {
        if (n && n.length) {
          this.defaultdata = n.slice(0, 4);
        }
      },
      jsondata(n) {
        this.exceldata = n;
      },
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    },
    methods: {
      ...methods,
    },
    mounted() {
      this.setData()
    },
  };
  </script>
  
  <style scoped lang="scss">
  @font-face {
    font-family: "Benmo-Ziyu";
    src: url("../../assets/fonts/Benmo-Ziyu.woff2");
  }
  
  .lt {
    width: 435px;
    height: 240px;
    display: flex;
    padding: 10px 0;
    position: relative;
    pointer-events: auto;
    cursor: pointer;
    user-select: none !important; /* 禁止文本和图片被选中 */
  }
  
  .lt-bottom {
    margin: 7px 0 0;
    // height: 240px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-left: -34px;
  }
  
  .lt-bt-item {
    width: 220px;
    margin-bottom: 16px;
    height: 93px;
    position: relative;
  }
  
  .lt-bt-item:nth-child(2n) {
    margin-left: -10px;
  }
  
  .bt-bg-img {
    position: absolute;
    width: 240px;
    height: 93px;
  }
  
  .bt-icon {
    position: absolute;
    width: 30px;
    height: 30px;
    left: 56px;
    top: 8px;
  }
  
  .lt-item-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #afc2df;
    width: 200px;
    line-height: 19px;
    position: absolute;
    top: 14px;
    left: 90px;
  }
  
  .lt-item-content {
    display: flex;
    position: absolute;
    top: 56px;
    left: 70px;
  }
  
  .item-num {
    font-family: Benmo-Ziyu;
    font-weight: 400;
    font-size: 20px;
    color: #3fc5ff;
    line-height: 20px;
  }
  
  .item-val {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #afc2df;
    line-height: 19px;
  }
  
  .item-fh {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    margin: -4px 6px 0;
    color: #afc2df;
  }
  
  .item-unit {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #a6bbd9;
    line-height: 19px;
    margin-left: 4px;
  }
  </style>
  